import React, { useState } from "react";
import Navbar from "../components/common/Navbar";
import DocumentsPageHeader from "../components/common/DocumentsPageHeader";
import PdfViewer from "../components/pdf-viewer/PdfViewer";
import TrashDocumentsTable from "../components/bin/document-bin/TrashDocumentsTable";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CloseIcon from "@mui/icons-material/Close";

import "../styles/Users.css";
import "../styles/TrashDocuments.css";
import "../styles/Documents.css";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

/*** Main component for listing all the soft deleted documents.
 * Opening a document replaces the list with the PDF viewer inline,
 * using the breadcrumb "Recycle Bin > Documents > {name}" pattern
 * (no tab strip). ***/
const TrashDocuments = () => {
  const [documentDetails, setDocumentDetails] = useState(null);

  // Called by TrashDocumentsTable when a document name is clicked.
  const addDocumentTab = (document) => {
    setDocumentDetails(document);
  };

  // Return to the list view.
  const closeDocumentView = () => {
    setDocumentDetails(null);
  };

  const openDocumentName =
    documentDetails?.update_document_name || documentDetails?.document_name;

  return (
    <div className="document-container">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="documents-content trash-content documents-standard-content">
        <DocumentsPageHeader
          showBreadcrumb={!!documentDetails}
          breadcrumbs={[
            { label: "Recycle Bin" },
            { label: "Documents", onClick: closeDocumentView },
            ...(documentDetails
              ? [{ label: openDocumentName }]
              : []),
          ]}
          showHeader={!documentDetails}
          headerSpacingClass="py-3"
          icon={DeleteOutlineIcon}
          title="All Deleted Documents"
          description="Review and restore deleted documents"
        />

        <div className={`tab-content${documentDetails ? ' relative' : ''}`}>
          {/* Close button - overlaid at top-right of the document viewer */}
          {documentDetails && (
            <button
              onClick={closeDocumentView}
              className="absolute top-2 right-3 z-10 flex items-center justify-center w-8 h-8 rounded-md bg-red-600 hover:bg-red-700 text-white transition-colors shadow-sm"
              title="Close Viewer"
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </button>
          )}
          {documentDetails ? (
            <DndProvider backend={HTML5Backend}>
              <PdfViewer
                documentType={documentDetails.document_type}
                clientID={documentDetails.client_id}
                documentID={documentDetails.document_id}
                documentTitle={documentDetails.update_document_name}
                documentURL={documentDetails.document_url}
                documentCreatedAt={documentDetails.created_at}
                changeActiveTab={closeDocumentView}
                document_table="documents"
                document_version={documentDetails.document_version}
                showPdfOnly={true}
              />
            </DndProvider>
          ) : (
            <TrashDocumentsTable addDocumentTab={addDocumentTab} />
          )}
        </div>
      </div>
    </div>
  );
};

export default TrashDocuments;
